import axios from "axios"
const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const submitAuthorizationApproval = async (isApproved) => {
  const url = `${PROGUIDES_WEB_URL}oauth/authorize/approval`
  const body = {
    is_approved: isApproved,
  }
  return await axios.post(url, body)
}



// WEBPACK FOOTER //
// ./src/store/oauth/oauth.apis.js